import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import th from './th.json';
import fr from './fr.json';
import ru from './ru.json';
import de from './de.json';
import vi from './vi.json';
import ko from './ko.json';
import zh from './zh.json';
import ja from './ja.json';
import es from './es.json';
import it from './it.json';
import ms from './ms.json';
import he from './he.json';   // EV-812 — Hebrew (UI falls back to en; event descriptions show Hebrew)
import pt from './pt.json';   // EV-812 — Brazilian Portuguese

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      th: { translation: th },
      fr: { translation: fr },
      ru: { translation: ru },
      de: { translation: de },
      vi: { translation: vi },
      ko: { translation: ko },
      zh: { translation: zh },
      ja: { translation: ja },
      es: { translation: es },
      it: { translation: it },
      ms: { translation: ms },
      he: { translation: he },
      pt: { translation: pt },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'th', 'fr', 'ru', 'de', 'vi', 'ko', 'zh', 'ja', 'es', 'it', 'ms', 'he', 'pt'],
    // 🔴 I18N-09: the browser reports a region-tagged code (e.g. 'vi-VN', 'de-DE',
    // 'en-US'). supportedLngs only lists base codes, so without these two a
    // Vietnamese ('vi-VN') visitor failed to match 'vi' and fell back to English.
    // load:'languageOnly' strips the region ('vi-VN' -> 'vi'); nonExplicitSupportedLngs
    // lets a region-tagged detection resolve to its base. → brand-new visitors now
    // auto-open in their browser language (vi/de/ru/…), no manual switch needed.
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'hl_locale',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
